import React from 'react';
import { Link } from 'react-router-dom';
import "../../css/Home.css";

const PictureHome = () => {
  return (
    <div className="abt-us-main-div">
      <img
        className="about-us-video"
        id="imgidpicture"
        src="https://res.cloudinary.com/dqjsq4btr/image/upload/v1741406549/container-image_yacrgq.jpg"
        alt="Speed meets excellence"
      />

      <div id="allelementspicture">
        <h1 id="pictureimgheading">Where speed meets excellence</h1>
        <h5 id="pictureimgparagraph">Keeping supply chains flowing in a world of change</h5>

        <div className="button-wrapper" id="divpicturebtndiv">
          <Link to="/contact-us" className="button-home-front" id="divpicturebtn">
            Contact us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PictureHome;